import {
  tenantInfoEndpoint,
  currentBaseURL,
  rotateCredentialsEndpoint,
  deleteCreatedUserEndpoint,
  deleteCredentialsEndpoint,
  URL_GET_TENANT_PRODUCTS,
} from "../endpoints";
import axiosInstance from "../axiosInstance";
import {
  OLD_SECRET_DELETE_FAILURE,
  OLD_SECRET_DELETE_SUCCESS,
  SECRET_ROTATION_NEW_SECRET_GENERATE_FAILURE,
  SECRET_ROTATION_NEW_SECRET_GENERATE_SUCCESS,
  trackEvent,
} from "../../analytics";

const getTenantInfo = async (environment) => {
  try {
    const response = await axiosInstance.get(`${currentBaseURL}/${tenantInfoEndpoint}?environment=${environment.toUpperCase()}`);
    if (response.status === 200) {
      return response.data.data;
    } else {
      throw new Error("No API credentials found");
    }
  } catch (error) {
    throw error.message;
  }
};

const rotateClientSecret = async ({ tenantId, clientId, tenantCredentialId, password, environment }) => {
  try {
    const response = await axiosInstance.post(`${currentBaseURL}/${rotateCredentialsEndpoint}`, {
      tenant_id: tenantId,
      client_id: clientId,
      tenant_credential_id: tenantCredentialId,
      password: password,
      environment: environment.toUpperCase(),
    });
    if (response.status === 200) {
      trackEvent(SECRET_ROTATION_NEW_SECRET_GENERATE_SUCCESS);
      return response;
    }
  } catch (error) {
    trackEvent(SECRET_ROTATION_NEW_SECRET_GENERATE_FAILURE, {
      failure_reason: error?.response?.data?.error?.message,
    });
    throw error.response.data.error;
  }
};

const deleteClientSecret = async ({ tenantId, clientId, tenantCredentialId, environment, timeLeftToExpiry }) => {
  try {
    const response = await axiosInstance.post(`${currentBaseURL}/${deleteCredentialsEndpoint}`, {
      tenant_id: tenantId,
      client_id: clientId,
      tenant_credential_id: tenantCredentialId,
      environment: environment.toUpperCase(),
    });
    trackEvent(OLD_SECRET_DELETE_SUCCESS, { old_secret_time_to_expiry: timeLeftToExpiry });
    return response.data;
  } catch (error) {
    trackEvent(OLD_SECRET_DELETE_FAILURE, {
      old_secret_time_to_expiry: timeLeftToExpiry,
      failure_reason: error?.response?.data?.error?.message,
    });
    throw new Error(error);
  }
};

const checkProductsEnabledForTenant = async (environment) => {
  try {
    const response = await axiosInstance.get(`${currentBaseURL}/${URL_GET_TENANT_PRODUCTS}?environment=${environment.toUpperCase()}&is_enabled=true`);
    // const data = {
    //   tenant_app_products: [
    //     {
    //       tenant_app_id: "5bb5c5e8-7970-4567-8c7b-745722b6a482",
    //       product_id: "d1593e65-0d56-457f-9569-57093455a795",
    //       is_enabled: true,
    //     },
    //     {
    //       tenant_app_id: "5bb5c5e8-7970-4567-8c7b-745722b6a482",
    //       product_id: "1d58f4bb-e8bd-4b1f-9758-38cb09778af4",
    //       is_enabled: false,
    //     },
    //   ],
    // };
    return response.data;
  } catch (err) {
    throw err.message;
  }
};

export { rotateClientSecret, deleteClientSecret, getTenantInfo, checkProductsEnabledForTenant };
